import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import useQueryParams from "../hooks/useQueryParams.js";
import ContactPage from "../pages/ContactPage.js";
import NoPage from "../pages/NoPage.js";

const FAQsPage = lazy(() => import("../features/content/pages/FAQsPage.js"));
const StaticContent = lazy(
  () => import("../features/content/pages/StaticContentPage.js"),
);
const ErrorPage = lazy(() => import("../pages/ErrorPage.js"));
const HomePage = lazy(() => import("../pages/HomePage.js"));
const ProductsPage = lazy(() => import("../pages/ProductsPage.js"));
const ExperiencesPage = lazy(() => import("../pages/ExperiencesPage.js"));
const CheckoutPage = lazy(() => import("../pages/CheckoutPage.js"));
const OrderConfirmationPage = lazy(
  () => import("../pages/OrderConfirmationPage.js"),
);
const OrderModification = lazy(() => import("../pages/OrderModification.js"));
const RebookingPage = lazy(() => import("../pages/RebookingPage.js"));
const VRMLandingPage = lazy(() => import("../pages/VRMLandingPage.js"));
const ModificationPopup = lazy(
  () => import("../features/offer/components/ModificationPopup.js"),
);
const SimpleLayout = lazy(() => import("../layout/SimpleLayout.js"));
const Layout = lazy(() => import("../layout/Layout.js"));

const Router = () => {
  const { quoteNumber, coId, isGearPlus } = useQueryParams();

  return (
    <Routes>
      <Route element={<SimpleLayout />}>
        <Route path="error" element={<ErrorPage />} />
        <Route path="faqs" element={<FAQsPage />} />
        <Route
          path="terms-of-use"
          element={<StaticContent contentType="termsOfUsePage" />}
        />
        <Route
          path="privacy-policy"
          element={<StaticContent contentType="privacyPolicy" />}
        />
        <Route
          path="terms-and-conditions"
          element={<StaticContent contentType="vrmEquipmentPage" />}
        />
        <Route path="contact-us" element={<ContactPage />} />
      </Route>
      {!coId ? (
        <Route element={<SimpleLayout />}>
          <Route path="*" element={<NoPage />} />
        </Route>
      ) : (
        <>
          {quoteNumber ? (
            <>
              <Route element={<SimpleLayout />}>
                <Route path="checkout" element={<CheckoutPage />} />
                <Route
                  path="order/:orderID/confirm"
                  element={<OrderConfirmationPage />}
                />
                <Route path="order-summary" element={<OrderModification />} />
              </Route>
              <Route
                element={
                  <>
                    <Layout />
                    <ModificationPopup />
                  </>
                }
              >
                <Route path="home" element={<HomePage />} />
                <Route path="gear/:category?" element={<ProductsPage />} />
                {isGearPlus && (
                  <Route path="experiences" element={<ExperiencesPage />} />
                )}
                <Route index element={<HomePage />} />
              </Route>
            </>
          ) : (
            <Route element={<SimpleLayout />}>
              <Route path="rewards" element={<RebookingPage />} />
              <Route index element={<VRMLandingPage />} />
            </Route>
          )}
        </>
      )}
    </Routes>
  );
};

export default Router;
